import {
  LOAD_ALL_MEETING_REPORTS,
  LOAD_SINGLE_MEETING_REPORT,
} from "./MeetingReportsList.saga";

export const loadAllMeetingReports = (payload) => ({
  type: LOAD_ALL_MEETING_REPORTS.LOADING,
  payload,
});

export const loadSingleMeetingReport = (payload) => ({
  type: LOAD_SINGLE_MEETING_REPORT.LOADING,
  payload,
});
